import styled from 'styled-components'
export const BoardsListControllerLoadingWrapper = styled.div`
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   margin-left: 16px;
   margin-top: 24px;
`
export const ProjectsOrTeamLoadingWrapper = styled.div`
   margin-bottom: 32px;
`
export const ProjectOrTeamDropDown = styled.div`
   display: flex;
`
export const BoardsListLoadingWrapper = styled.div``
